import type { Api } from '@pflegenavi/shared-frontend/platform';
import {
  get,
  getApiBaseUrl,
  modify,
} from '@pflegenavi/shared-frontend/platform';
import type { Tenant } from '@pflegenavi/frontend/tenant';
import type { AuthenticationContext } from '@pflegenavi/frontend/authentication';
import type {
  ServiceProviderControllerBodyTypes,
  ServiceProviderControllerResultTypes,
} from '@pflegenavi/service-provider-shared/api-endpoints';
import { ServiceProviderControllerDefinition } from '@pflegenavi/service-provider-shared/api-endpoints';

export interface IServiceProviderApi extends Api {
  getServiceProvider(dataIn: {
    params: {
      globalServiceProviderId: string;
    };
  }): Promise<ServiceProviderControllerResultTypes['getServiceProvider']>;

  updateServiceProvider(dataIn: {
    params: { globalServiceProviderId: string };
    body: ServiceProviderControllerBodyTypes['updateServiceProvider'];
  }): Promise<ServiceProviderControllerResultTypes['updateServiceProvider']>;
}

export class ServiceProviderApi implements IServiceProviderApi {
  baseUrl: string;

  getServiceProvider: IServiceProviderApi['getServiceProvider'];
  updateServiceProvider: IServiceProviderApi['updateServiceProvider'];

  constructor(
    tenantId: Tenant,
    public authContext: AuthenticationContext,
    apiUrl?: string
  ) {
    this.baseUrl = getApiBaseUrl(tenantId, apiUrl);

    this.getServiceProvider = get({
      authContext,
      url: (params) => {
        return `${this.baseUrl}/${ServiceProviderControllerDefinition.controller}/${ServiceProviderControllerDefinition.endpoints.getServiceProvider.url}`.replace(
          ':globalServiceProviderId',
          params.globalServiceProviderId
        );
      },
    });

    this.updateServiceProvider = modify({
      authContext,
      method: 'PUT',
      url: (params) => {
        return `${this.baseUrl}/${ServiceProviderControllerDefinition.controller}/${ServiceProviderControllerDefinition.endpoints.updateServiceProvider.url}`.replace(
          ':globalServiceProviderId',
          params.globalServiceProviderId
        );
      },
    });
  }
}
